module.exports = __webpack_public_path__ + "img/AMWETCarousel_sitOnFloor.cce71295.webp";